// extracted by mini-css-extract-plugin
module.exports = {"Table":"style_Table__2HCin"};